const quickTags = [
  { label: "法国", href: "#france" },
  { label: "意大利", href: "#italy" },
  { label: "西班牙", href: "#spain" },
  { label: "德国", href: "#germany" },
  { label: "英国", href: "#uk" },
  { label: "其他欧洲", href: "#other" },
];

const stats = [
  { value: "6", label: "地域分区" },
  { value: "27", label: "代表作品" },
  { value: "7", label: "核心母题" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[520px] md:min-h-[660px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20abstract%20cinematic%20background%20inspired%20by%20European%20art%20house%20cinema%2C%20deep%20burgundy%20and%20warm%20amber%20tones%2C%20soft%20film%20grain%20texture%2C%20dramatic%20chiaroscuro%20light%20falling%20through%20a%20tall%20window%2C%20moody%20elegant%20minimal%20editorial%20composition&width=1920&height=1080&seq=ethfilm-hero-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-28">
        <div className="max-w-3xl rf-fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-accent-500/20 border border-accent-300/40 text-accent-100 text-xs md:text-sm tracking-wide">
            <i className="ri-compass-3-line" aria-hidden="true"></i>
            欧洲艺术电影 · 道德困境的观看指南
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-[3.4rem] font-bold leading-tight text-white">
            欧美伦理电影：从法国到东欧的道德叙事图谱
          </h1>

          <p className="mt-5 text-sm md:text-base leading-relaxed text-white/80 max-w-2xl">
            这是一个围绕「伦理电影」整理的地域索引站。我们把法国、意大利、西班牙、德国、英国以及更广阔的欧洲作品，
            按地域与母题重新编排，帮助你快速找到下一部想看的严肃剧情片。
          </p>

          <div className="mt-7 flex flex-wrap gap-2.5">
            {quickTags.map((tag) => (
              <a
                key={tag.href}
                href={tag.href}
                className="px-4 py-2 rounded-full bg-white/10 border border-white/25 text-white text-sm hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap backdrop-blur-sm"
              >
                {tag.label}
              </a>
            ))}
          </div>

          <div className="mt-9 flex flex-wrap gap-x-8 gap-y-4">
            {stats.map((s) => (
              <div key={s.label} className="flex items-baseline gap-2">
                <span className="font-heading text-2xl md:text-3xl font-bold text-accent-400">{s.value}</span>
                <span className="text-xs md:text-sm text-white/70">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}